import Footer from "./components/Footer";
import "./styles/styles.scss";
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";

import Index from "./pages/index";
import Premios from "./pages/premios";
import Galeria from "./pages/galeria";
import Registro from "./pages/registro";
import Anteriores from "./pages/anteriores";
import Bases from "./pages/bases";
import Header from "./components/Header";
import React, { useEffect, useState } from "react";

// Todo lo global de la aplicación se realiza en este archivo



const Layout = () => {

  const [route, setRoute] = useState(null); 

  useEffect(() => {

    let now = new Date();
    let hour = now.getHours();
    let day = now.getDate();
    let month = now.getMonth() + 1;
    let year = now.getFullYear();
    
    if(day >= 1 && day <= 29 && month === 7 && year === 2022){
      setRoute("/registro");
    }else{
      setRoute("/");
    }
  }, []);


  return (
    <Router basename="/CasateConMartha2022">
      <Header />
      <Switch>
        <Route exact path="/" component={Index} />
        <Route exact path="/premios" component={Premios} />
        <Route exact path="/galeria" component={Galeria} />
        <Route exact path={route} component={Registro}/>
        <Route exact path="/anteriores" component={Anteriores} />
        <Route exact path="/bases" component={Bases} />
        <Redirect to="/" />
      </Switch>
      <Footer />
    </Router>
  );
};

export default Layout;
